import { Fragment, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  CancelButton,
  Accept,
  Reject,
  PrimaryButton,
} from "../../css components/Button";
import { useAxios, useComponent } from "../../../hooks";
import pages from "../../../constants/pages";
import Dialog from "../../../components/Dialog";

export default function ActionButton({ ID = "", setFormData, formData }) {
  const axios = useAxios();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { alert } = useComponent();
  const [dialogState, setDialogState] = useState({
    state: false,
    data: {},
  });

  const [loading, setLoading] = useState({
    REJECTED: false,
    APPROVE: false,
    PENDING: false,
  });

  function handleCancel() {
    navigate(-1);
  }

  return (
    <Fragment>
      <CancelButton
        onClick={handleCancel}
        variant="outlined"
        style={{ marginRight: "10px" }}
      >
        {"Back"}
      </CancelButton>

      <PrimaryButton
        style={{ marginRight: "10px" }}
        variant="contained"
        disabled={!formData.steps.step2}
        onClick={() =>
          navigate(
            pages.unverifiedCompanyAgencyDetails.route +
              "?agencyID=" +
              ID +
              "&platformID=" +
              formData.platformID
          )
        }
      >
        {formData.steps.step2 ? "Company Details" : "No Company Details"}
      </PrimaryButton>

      {(!formData.status || formData.status === "APPROVE") && (
        <Reject
          style={{ marginRight: "10px" }}
          size="large"
          variant="contained"
          loading={loading.REJECTED}
          onClick={() =>
            setDialogState({
              state: true,
              data: {
                brand: formData,
                status: 2,
                title: "Do You want to reject this agency?",
                dangerButton: "Reject Agency",
                function: handleAgree,
              },
            })
          }
        >
          Reject
        </Reject>
      )}

      {(!formData.status || formData.status === "REJECTED") && (
        <Accept
          style={{ marginRight: "10px" }}
          size="large"
          variant="contained"
          loading={loading.APPROVE}
          onClick={() =>
            setDialogState({
              state: true,
              data: {
                brand: formData,
                status: 1,
                title: "Do You want to approve this agency?",
                primaryButton: "Approve Agency",
                function: handleAprove,
              },
            })
          }
        >
          Approve
        </Accept>
      )}

      <Dialog
        dialogState={dialogState}
        setDialogState={setDialogState}
        handleAgree={dialogState.data?.function}
        dialogContent={{
          title: dialogState.data?.title,
          dangerButton: dialogState.data?.dangerButton,
          primaryButton: dialogState.data?.primaryButton,
        }}
      />
    </Fragment>
  );

  function handleAgree() {
    handleCampaignStatus(2, "REJECTED");
  }

  function handleAprove() {
    handleCampaignStatus(1, "APPROVE");
  }

  function handleCampaignStatus(s, status) {
    setLoading((prev) => ({
      ...prev,
      [status]: true,
    }));

    axios({
      url: "/agency/verification/action",
      method: "POST",
      disableRedirect: true,
      data: {
        agency_id: ID,
        agency_status: s,
      },
    }).then((response) => {
      if (response.status) {
        dispatch(alert.success(response.message.displayMessage));
        setFormData((formData) => ({
          ...formData,
          status: status,
        }));
      }
      setLoading((prev) => ({
        ...prev,
        [status]: false,
      }));
    });
  }
}
